module.exports = __webpack_public_path__ + "static/media/line-icons-r.c7d485a7.svg";